<template>
    <div>
        <card-header title="Edit Session" icon="fa-pencil"/>

        <card-body>
            <rmc-session-form :session="session"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteSession"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Session?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!session.title || !session.start_at || !session.end_at"
                    ><i class="fas fa-check mr-2"></i>Save Session
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import RmcConferenceForm from "@/cards/RMC/conferences/ConferenceForm";

    import {client as http} from '@/http_client';
    import moment from "moment";
    import RmcSessionForm from "./SessionForm";

    export default {
        components: {RmcSessionForm, RmcConferenceForm, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                session: {},
                confirmDelete: false,
                dirty: null
            };
        },
        methods: {
            loadSession: function() {
                this.$emit('loading', true);
                http.get('rmc/sessions/' + this.props.sessionId, {force: true}).then(response => {
                    response.data.start_at = moment(response.data.start_at).toDate();
                    response.data.end_at = moment(response.data.end_at).toDate();
                    this.session = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            submit: function() {
                http.put('rmc/sessions/' + this.props.sessionId, this.session, {force: true}).then(response => {
                    this.$reloadCard('rmc-session', {sessionId: this.props.sessionId});
                    this.$reloadCard('rmc-sessions', {});
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the session.');
                    this.$emit('loading', false);
                });
            },
            deleteSession() {
                if (this.confirmDelete) {
                    this.$emit('loading', true);

                    http.delete('rmc/sessions/' + this.props.sessionId).then(response => {
                        this.$reloadCard('rmc-session', {sessionId: this.props.sessionId});
                        this.$reloadCard('rmc-sessions', {});
                        this.$saveAlert(false);
                        this.$closeCard(this.card);
                    }).catch(err => {

                    });
                } else {
                    this.confirmDelete = true;
                    setTimeout(() => {
                        this.confirmDelete = false;
                    }, 3000);
                }
            }
        },
        watch: {
            'props.sessionId': function() {
                this.dirty = null;
                this.loadSession();
            },
            'conference': {
                deep: true,
                handler: function() {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this session? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadSession();
        }
    };
</script>
